module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-inline-block u-valign-middle t-text--md c-matches-table-row__score u-align-center u-fit-w"
  }, [((_vm.status === 'is-today' && _vm.isLive) || _vm.status === 'is-past') ? _c('div', [(_vm.isLive) ? _c('div', {
    staticClass: "c-match--live-logo u-relative u-inline-block u-valign-middle"
  }, [_c('img', {
    attrs: {
      "src": "/static/shape/shape-hexagon-full--outline.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-absolute u-pos-center"
  }, [_c('p', {
    staticClass: "u-table-cell u-valign-middle u-uppercase u-color--black t-text--bold t-text--sm"
  }, [_vm._v(_vm._s(_vm.contentGlobal.taxonomies.matches.live))])])]) : _c('div', [_c('span', {
    staticClass: "u-inline-block u-valign-middle t-text--xxxl t-text--bold u-color--gray"
  }, [_vm._v(_vm._s(_vm.match.teamOneScore))]), _vm._v(" "), _c('span', {
    staticClass: "u-inline-block u-valign-middle t-text--xxxl t-text--bold u-color--gray u-marg-l-lg"
  }, [_vm._v(_vm._s(_vm.match.teamTwoScore))])])]) : (_vm.status === 'is-today' && !_vm.isLive) ? _c('div', {
    staticClass: "u-uppercase"
  }, [_c('div', {
    staticClass: "t-text--sm"
  }, [_vm._v(_vm._s(_vm.contentGlobal.taxonomies.matches.beginsAt))]), _vm._v(" "), _c('div', {
    staticClass: "t-text--xl t-text--bold u-marg-t-xxxs",
    domProps: {
      "innerHTML": _vm._s(_vm._getBegins())
    }
  })]) : (_vm.status === 'is-upcoming' && !_vm.isLive) ? _c('div', {
    staticClass: "u-uppercase"
  }, [_c('div', {
    staticClass: "t-text--sm"
  }, [_vm._v(_vm._s(_vm.contentGlobal.taxonomies.matches.beginsIn))]), _vm._v(" "), _c('div', {
    staticClass: "t-text--xl t-text--bold u-marg-t-xxxs",
    domProps: {
      "innerHTML": _vm._s(_vm._getBegins())
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6acec9b4"}!./src/scripts/components/app-matches-table-counter/template.html
// module id = 931
// module chunks = 0